import { Injectable } from '@angular/core';
import { NgxPhoneConstants } from '../../constants/ngx';

@Injectable({
    providedIn: 'root',
})
export class PhoneNumberService {
    getPhoneNumber(phoneNumber: string) {
        return phoneNumber.replaceAll('-', '');
    }

    getPhoneNumberAndExtension(phoneNumber: string) {
        phoneNumber = phoneNumber.replace(
            NgxPhoneConstants.EMPTY_PHONE_NUMBER_EXTENSION,
            '',
        );
        const [phone, extension] = phoneNumber.split(
            NgxPhoneConstants.PHONE_NUMBER_AND_EXTENSION_SEPARATOR,
        );
        return {
            phoneNumber: phone.replaceAll('-', ''),
            phoneNumberExtension: extension === '' ? undefined : extension,
        };
    }

    buildPhoneNumberString(phoneNumber: string, phoneNumberExtension?: string) {
        if (!phoneNumber) {
            return '';
        }

        phoneNumber = phoneNumber.replaceAll('-', '');

        const areaCode = phoneNumber.slice(0, 3);
        const firstPart = phoneNumber.slice(3, 6);
        const secondPart = phoneNumber.slice(6, 10);
        const extension = phoneNumberExtension;

        const extensionString = extension ? ` ext. ${extension}` : '';

        return `(${areaCode}) ${firstPart}-${secondPart}${extensionString}`;
    }

    buildPhoneNumberForInput(
        phoneNumber: string,
        phoneNumberExtension?: string,
    ) {
        if (!phoneNumber) {
            return '';
        }

        phoneNumber = phoneNumber.replaceAll('-', '');
        return `${phoneNumber}${NgxPhoneConstants.PHONE_NUMBER_AND_EXTENSION_SEPARATOR}${phoneNumberExtension ?? ''}`;
    }
}
